import styled from 'styled-components'

const List = styled.ul`
  float: left;
  padding-left: 0;
  flex: 1 1 auto;
  text-align: left;
  margin: 3px 0 0 5px;
  list-style: none;

  ::before {
    content: ' ';
    display: table;
  }
`

const Item = styled.li`
  position: relative;
  float: left;
  border-left: 1px solid #ede9f2;

  :first-child {
    border-left: none;
  }
`
const Link = styled.a`
  text-align: left;
  position: relative;
  padding: 5px 0.5em;
  display: block;
  border-top: none;
  border-bottom: none;
  border-right: none;
  font-size: 16px;
  font-weight: bold;
  color: #68504c;
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;

  :hover {
    text-decoration: none;
    background-color: #eeeeee;
    color: #68504c;
  }

  ${props => props.theme.breakpoints.down('lg')} {
    font-size: 14px;
  }

  :focus {
    text-decoration: none;
    color: #68504c;
  }
`

export default ({ handleEquipmentAccordion }) => {
  return (
    <List>
      <Item>
        <Link id='header_auctions' href='/'>
          Auctions
        </Link>
      </Item>
      <Item>
        <Link id='header_buy' href='/buy'>
          Buy
        </Link>
      </Item>
      <Item>
        <Link id='header_sell' href='/sell'>
          Sell
        </Link>
      </Item>
      <Item>
        <Link id='header_results' href='/auction/results'>
          Results
        </Link>
      </Item>
      <Item>
        <Link id='header_equipment' onClick={handleEquipmentAccordion}>
          Equipment
        </Link>
      </Item>
      <Item>
        <Link id='header_appraisals' href='/appraisals'>
          Appraisals
        </Link>
      </Item>
      <Item>
        <Link id='header_about' href='/about'>
          About
        </Link>
      </Item>
    </List>
  )
}
